import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled, { keyframes } from "styled-components/macro";

const PHASE_INTERVAL_MS = 4000;

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const Bubble = styled.div`
  align-self: flex-start;
  width: 92%;
  max-width: 92%;
  padding: ${({ theme }) => theme.resolve("spacing_lg")} 14px;
  border-radius: ${({ theme }) => theme.resolve("radius_sm")};
  background-color: white;
  border: ${({ theme }) => theme.resolve("border_md")} solid
    ${({ theme }) => theme.primaryBorder};
  font-size: ${({ theme }) => theme.resolve("font_size_md")};
  line-height: 21px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.resolve("spacing_md")};
`;

const ShimmerLine = styled.div<{ widthPct: number }>`
  height: 12px;
  width: ${(p) => p.widthPct}%;
  border-radius: ${({ theme }) => theme.resolve("radius_xs")};
  background: linear-gradient(90deg, #eef0f3 0%, #f6f7f9 50%, #eef0f3 100%);
  background-size: 800px 100%;
  animation: ${shimmer} 1.4s linear infinite;
`;

const PhaseLabel = styled.div`
  font-size: ${({ theme }) => theme.resolve("font_size_sm")};
  font-style: italic;
  color: ${({ theme }) => theme.primaryTextColor};
  opacity: 0.7;
  margin-top: ${({ theme }) => theme.resolve("spacing_xxs")};
`;

export function PendingAssistantBubble() {
  const { t } = useTranslation();

  const phases = [
    t("Searching the portfolio…"),
    t("Looking up product details…"),
    t("Reading the documents…"),
    t("Composing the answer…"),
  ];

  const [phaseIdx, setPhaseIdx] = useState(0);
  useEffect(() => {
    const id = setInterval(() => {
      setPhaseIdx((i) => (i + 1) % phases.length);
    }, PHASE_INTERVAL_MS);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Bubble aria-busy="true" aria-live="polite">
      <ShimmerLine widthPct={88} />
      <ShimmerLine widthPct={72} />
      <ShimmerLine widthPct={58} />
      <PhaseLabel>{phases[phaseIdx]}</PhaseLabel>
    </Bubble>
  );
}
